import { convertBlobToBase64 } from '../../../../utils/file'

import {
  ACCEPTED_IMAGE_TYPES,
  MAX_INLINE_SIZE,
} from './useEditorAddFile.constants'

function isInlineImageType(file) {
  return Object.keys(ACCEPTED_IMAGE_TYPES).includes(file.type)
}

function isInlineImageTooLarge(file) {
  return file.size > MAX_INLINE_SIZE
}

async function toInlineImage(file) {
  return {
    base64: await convertBlobToBase64(file),
    blob: file,
    name: file.name,
  }
}

export function getInlineImageDropFiles(files) {
  return files.filter(isInlineImageType).reduce(
    (accumulator, file) => {
      if (isInlineImageTooLarge(file)) {
        accumulator.tooLargeFileNames.push(file.name)
      } else {
        accumulator.acceptedFiles.push(file)
      }

      return accumulator
    },
    { acceptedFiles: [], tooLargeFileNames: [] }
  )
}

export function toInlineImages(files) {
  return Promise.all(files.map(toInlineImage))
}
